import { HttpConfig } from './http.types';

import { API_URL } from 'src/env.json';

const config: HttpConfig = {
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=utf-8',
    // Note: Client-side CORS headers don't actually affect the CORS behavior
    // They're included here for documentation purposes but the server controls CORS
  },
};

const setBaseUrl = (baseUrl: string) => {
  Object.assign(config, { baseURL: baseUrl }); // Fix: use baseURL not baseUrl to match the property name
};

const updateClientConfig = (newOptions: HttpConfig) => {
  Object.assign(config, newOptions);
};

const addHeader = (key: string, value: string) => {
  Object.assign(config.headers, { [key]: value });
};

const removeHeader = (key: string) => {
  delete config.headers[key];
};

const setBearerToken = (token: string) => {
  addHeader('Authorization', `Bearer ${token}`);
};

const removeBearerToken = () => {
  removeHeader('Authorization');
};

const hasBearerToken = () => {
  return !!config.headers['Authorization'] && !!config.headers['Authorization'].split(' ')?.[1];
};

const httpConfig = {
  options: config,
  setBaseUrl,
  updateClientConfig,
  addHeader,
  removeHeader,
  setBearerToken,
  removeBearerToken,
  hasBearerToken,
} as const;

export { httpConfig };
